export const API_URL = "https://prod.easypointapi.com/api/"